// Ported from the supplied PicPlayer src/header-config.js, 2026-09-24.
/**
 * Header navigation, in display order. Each nested array is one submenu group;
 * the renderer inserts a horizontal separator between groups automatically.
 */
export const NETWORK_MENUS = [
  { label: 'Create', groups: [['Artboardr']] },
  { label: 'Imagine', groups: [
    ['PicPlayer', 'DrawDomain', 'RefineRaw'],
    ['FocalFolio'],
    ['LayoutLift', 'UIUniverse'],
    ['SceneShaper', 'AnimateArena', 'EffectsEngine'],
    ['DecibelDesk', 'BandBeats'],
    ['StoryboardSmith', 'PaperPoet'],
  ] },
  { label: 'Organize', groups: [
    ['ParagraphPro', 'PresentPad', 'SumSmith'],
    ['NumberNode'],
    ['PDFPioneer', 'DynamicDiary'],
    ['PlannerPlatform', 'MapMedium'],
    ['TalkTerminal', 'LetterLayer'],
  ] },
  { label: 'Deploy', groups: [
    ['CreateConsole', 'CommitCove'],
    ['CoderCollab', 'WikiWorkspace'],
    ['RuntimeRocket', 'PlugPlayground'],
    ['AlarmAxis', 'UptimeUtility'], 
    ['ResolveRocket'],
  ] },
  { label: 'Expand', groups: [
    ['OnboardOrbit', 'CustomerCircuit'],
    ['ChannelChorus'],
    ['RevenueRollup'],
  ] },
  { label: 'Build', groups: [
    ['ConstructCanvas', 'ModelMotive'],
    ['KitConstructor'],
  ] },
  { label: 'Storage', groups: [['DocDome']] },
  { label: 'AI', groups: [
    ['BrainyBinary', 'NeuralNanny'],
    ['UsefulUtility'],
  ] },
  { label: 'Resources', groups: [
    ['CreateCanyon', 'GraphicGrounds', 'MelodyMerchant', 'ProgramPlaza', 'FileFoyer'],
  ] },
  { label: 'Network', groups: [['PhotoTalent', 'SupportSub']] },
  { label: 'Sim', groups: [['StorySim']] },
];

/**
 * Set real destinations here, then run `npm run build`.
 * Empty values deliberately do not guess third-party domains or navigate to
 * broken routes. ConstructCanvas stays in this editor. Other empty entries explain that no URL is set.
 * Configured apps open in a separate tab to preserve the current document.
 */
export const APP_URLS: Record<string, string> = {
  Artboardr: 'https://artboardr.com',
  StorySim: 'https://storysim.com',
  PicPlayer: 'https://picplayer.com',
  DrawDomain: 'https://drawdomain.com',
  RefineRaw: 'https://refineraw.com',
  LayoutLift: 'https://layoutlift.com',
  UIUniverse: 'https://uiuniverse.com',
  SceneShaper: 'https://sceneshaper.com',
  AnimateArena: 'https://animatearena.com',
  EffectsEngine: 'https://effectsengine.com',
  DecibelDesk: 'https://decibeldesk.com',
  BandBeats: 'https://bandbeats.com',
  PaperPoet: 'https://paperpoet.com',
  StoryboardSmith: 'https://storyboardsmith.com',
  FocalFolio: 'https://focalfolio.com',
  ParagraphPro: 'https://paragraphpro.com',
  PresentPad: 'https://presentpad.com',
  SumSmith: 'https://sumsmith.com',
  NumberNode: 'https://numbernode.com',
  PDFPioneer: 'https://pdfpioneer.com',
  DynamicDiary: 'https://dynamicdiary.com',
  PlannerPlatform: 'https://plannerplatform.com',
  MapMedium: 'https://mapmedium.com',
  TalkTerminal: 'https://talkterminal.com',
  LetterLayer: 'https://letterlayer.com',
  CreateConsole: 'https://createconsole.com',
  CommitCove: 'https://commitcove.com',
  CoderCollab: 'https://codercollab.com',
  WikiWorkspace: 'https://wikiworkspace.com',
  RuntimeRocket: 'https://runtimerocket.com',
  PlugPlayground: 'https://plugplayground.com',
  AlarmAxis: 'https://alarmaxis.com',
  UptimeUtility: 'https://uptimeutility.com',
  ResolveRocket: 'https://resolverocket.com',
  OnboardOrbit: 'https://onboardorbit.com',
  CustomerCircuit: 'https://customercircuit.com',
  ChannelChorus: 'https://channelchorus.com',
  RevenueRollup: 'https://revenuerollup.com',
  ConstructCanvas: 'https://constructcanvas.com',
  ModelMotive: 'https://modelmotive.com',
  KitConstructor: 'https://kitconstructor.com',
  DocDome: 'https://docdome.com',
  BrainyBinary: 'https://brainybinary.com',
  NeuralNanny: 'https://neuralnanny.com',
  UsefulUtility: 'https://usefulutility.com',
  CreateCanyon: 'https://createcanyon.com',
  GraphicGrounds: 'https://graphicgrounds.com',
  MelodyMerchant: 'https://melodymerchant.com',
  ProgramPlaza: 'https://programplaza.com',
  FileFoyer: 'https://filefoyer.com',
  PhotoTalent: 'https://phototalent.com',
  SupportSub: 'https://supportsub.com',
};

